import { DocumentData, Firestore, QuerySnapshot } from 'firebase/firestore';
import { typeUniqueId } from "../../../../dataObjects/types"
import { FirebaseAppSingleton } from "../../../cloudServices/googleFirebaseServices/FirebaseAppSingleton";
import { FirestoreDbContext } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDbContext";
import { IFirestoreDigitalMediaRepository, FirestoreDigitalMediaRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDigitalMediaRepository";


export function getDigitalMediaBaseForParentId_onSnapshot(parentId: typeUniqueId, callback: (snapshot: QuerySnapshot<DocumentData>) => void): Promise<() => void> {
  return new Promise<() => void>(async (resolve, reject) => {
    try {
      // initialize a Firestore object instance
      const firestoreObj: Firestore = FirebaseAppSingleton.firestore;
      // instantiate a FirestoreDbContext
      const dbContext = new FirestoreDbContext('firestoreDb', firestoreObj);

      const firestoreDigitalMediaRepository: IFirestoreDigitalMediaRepository = new FirestoreDigitalMediaRepository(dbContext);

      // fetch the DigitalMedia base object for the pertinent parentId
      const unsubscribeCallback: () => void = await firestoreDigitalMediaRepository.getForParent_onSnapshot(parentId, callback);

      resolve(unsubscribeCallback);
    }
    catch (error: any) {
      reject(error);
    }
  });
}